import { Node_Type } from "./../../ricos-types/index.js";
import TableCell from "./table-cell.js";
import TableRow from "./table-row.js";
import Table from "./table.js";
const nodeViewRenderers = {
  [Node_Type.TABLE]: Table,
  [Node_Type.TABLE_ROW]: TableRow,
  [Node_Type.TABLE_CELL]: TableCell
};
export {
  nodeViewRenderers
};
//# sourceMappingURL=node-view-renderers.js.map
